import React, { useState } from "react";
import MaterialsScreen from "./MaterialsScreen";
import PatchesScreen from "./PatchesScreen";
import BaseScreen from "./BaseScreen";

// maps products.components _id to screens
const Components = {
  materials: MaterialsScreen,
  patches: PatchesScreen,
  base: BaseScreen,
};

export const CreateScreens = ({ componentsState, productsState, ...props }) => {
  const [openNestedAccordion, setOpenNestedAccordion] = useState(null);
  const openObjState = { state: openNestedAccordion, setState: setOpenNestedAccordion };

  const nonCartSteps = productsState.activeObj.category.filter((s) => s._id !== "shopping_cart");

  return nonCartSteps.map((step) =>
    typeof Components[step._id] !== "undefined"
      ? React.createElement(Components[step._id], {
          key: step._id,
          componentsState,
          productsState,
          openObjState,
          ...props,
        })
      : null
  );
};
